@if (applicationForm()) {
  <p-card class="custom-card">
    <div class="section-title">Dane podstawowe</div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div>
        <div class="field-label">Kod wniosku</div>
        <div class="field-value">{{ applicationForm()!.kod }}</div>
      </div>
      <div>
        <div class="field-label">Nazwa</div>
        <div class="field-value">{{ applicationForm()!.nazwa }}</div>
      </div>
      <div>
        <div class="field-label">Grupa</div>
        <div class="field-value">{{ areaLabel(applicationForm()!.grupa) }}</div>
      </div>
      <div>
        <div class="field-label">Kod techniczny</div>
        <div class="field-value">{{ applicationForm()!.kodTech }}</div>
      </div>
      <div>
        <div class="field-label">Wniosek usunięty</div>
        <div class="field-value">
          {{ applicationForm()!.usuniety | booleanLabel }}
        </div>
      </div>
    </div>
  </p-card>

  <p-card class="custom-card mt-6">
    <div class="section-title">Widoczność i ograniczenia</div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <div class="field-label">Korespondencja</div>
        <div class="field-value">
          {{ applicationForm()!.czyKorespondencjaAktywna | booleanLabel }}
        </div>
      </div>
      <div>
        <div class="field-label">Wyświetlaj dla obszarów</div>
        <div class="field-value">
          {{ visibleForAreasLabels() | valueOrDash }}
        </div>
      </div>
      <div>
        <div class="field-label">Miesiąc od</div>
        <div class="field-value">
          {{ getMonthName(applicationForm()!.miesiacOd) | valueOrDash }}
        </div>
      </div>
      <div>
        <div class="field-label">Miesiąc do</div>
        <div class="field-value">
          {{ getMonthName(applicationForm()!.miesiacDo) | valueOrDash }}
        </div>
      </div>
      <div>
        <div class="field-label">Dzień od</div>
        <div class="field-value">
          {{ applicationForm()!.dzienOd | valueOrDash }}
        </div>
      </div>
      <div>
        <div class="field-label">Dzień do</div>
        <div class="field-value">
          {{ applicationForm()!.dzienDo | valueOrDash }}
        </div>
      </div>
    </div>
  </p-card>

  <div class="flex flex-wrap justify-end gap-2 mt-6">
    <p-button
      label="Wstecz"
      styleClass="customInfoButton outlined"
      (click)="onBack()"
    />
    <p-button label="Edytuj" styleClass="customInfoButton" (click)="onEdit()" />
  </div>
}
